var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouse3 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 26,
    cy: 26,
    r: 26
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    clipPath: "url(#clip0_1405_22090)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8156 42H12.9971L12.9971 17.7139H22.8156L22.8156 42Z",
    fill: "#FF8537"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8184 42H40V17.7139L31.4078 10.4292L22.8184 17.7139V42Z",
    fill: "#FFA063"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8185 17.7139H13L21.5893 10.4292H31.4078L22.8185 17.7139Z",
    fill: "#DF3030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 25.0014H15.4525V21.3591H17.9078V25.0014Z",
    fill: "#8DD4FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1473 25.3033H18.2158V21.0544H15.1473V25.3033ZM17.6027 24.6967H15.7604V21.661H17.6027V24.6967Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3631 25.0014H17.9078V21.3591H20.3631V25.0014Z",
    fill: "#8DD4FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6027 25.3033H20.6711V21.0544H17.6027V25.3033ZM20.0551 24.6967H18.2158V21.661H20.0551V24.6967Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 28.6409H15.4525V24.9986H17.9078V28.6409Z",
    fill: "#8DD4FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1473 28.9457H18.2158V24.6881H15.1473V28.9457ZM17.6027 28.3391H15.7604V25.3033H17.6027V28.3391Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3631 28.6409H17.9078V24.9986H20.3631V28.6409Z",
    fill: "#8DD4FC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6027 28.9457H20.6711V24.6881H17.6027V28.9457ZM20.0551 28.3391H18.2158V25.3033H20.0551V28.3391Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 34.7125H15.4525V31.0701H17.9078V34.7125Z",
    fill: "#FFDE0F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1473 35.0172H18.2158V30.7682H15.1473V35.0172ZM17.6027 34.4106H15.7604V31.3748H17.6027V34.4106Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3631 34.7125H17.9078V31.0701H20.3631V34.7125Z",
    fill: "#FFDE0F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6027 35.0172H20.6711V30.7682H17.6027V35.0172ZM20.0551 34.4106H18.2158V31.3748H20.0551V34.4106Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9078 38.3548H15.4525V34.7125H17.9078V38.3548Z",
    fill: "#FFDE0F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1473 38.6595H18.2158V34.4106H15.1473V38.6595ZM17.6027 38.0529H15.7604V35.0172H17.6027V38.0529Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3631 38.3548H17.9078V34.7125H20.3631V38.3548Z",
    fill: "#FFDE0F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6027 38.6595H20.6711V34.4106H17.6027V38.6595ZM20.0551 38.0529H18.2158V35.0172H20.0551V38.0529Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 25.0014H25.2738V21.3591H27.7291V25.0014Z",
    fill: "#FFDE0F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9658 25.3033H28.0342V21.0544H24.9658V25.3033ZM27.4211 24.6967H25.5789V21.661H27.4211V24.6967Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1815 25.0014H27.7262V21.3591H30.1815V25.0014Z",
    fill: "#FFDE0F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4211 25.3033H30.4896V21.0544H27.4211V25.3033ZM29.8736 24.6967H28.0342V21.661H29.8736V24.6967Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 28.6409H25.2738V24.9986H27.7291V28.6409Z",
    fill: "#FFDE0F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9658 28.9457H28.0342V24.6881H24.9658V28.9457ZM27.4211 28.3391H25.5789V25.3033H27.4211V28.3391Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1815 28.6409H27.7262V24.9986H30.1815V28.6409Z",
    fill: "#FFDE0F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4211 28.9457H30.4896V24.6881H27.4211V28.9457ZM29.8736 28.3391H28.0342V25.3033H29.8736V28.3391Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2709 31.0701H30.1816V41.9971H25.2709V31.0701Z",
    fill: "#DF3030"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9658 42H30.4866V30.7682H24.9658V42ZM29.8735 42H25.5789V31.3633H29.8735V42Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7291 34.7125H25.2738V31.0701H27.7291V34.7125Z",
    fill: "#FFDE0F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9658 35.0172H28.0342V30.7682H24.9658V35.0172ZM27.4211 34.4106H25.5789V31.3748H27.4211V34.4106Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1815 34.7125H27.7262V31.0701H30.1815V34.7125Z",
    fill: "#FFDE0F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4211 35.0172H30.4896V30.7682H27.4211V35.0172ZM29.8736 34.4106H28.0342V31.3748H29.8736V34.4106Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0893 25.0014H32.634V21.3591H35.0893V25.0014Z",
    fill: "#FFDE0F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3405 25.3033H35.4089V21.0544H32.3405V25.3033ZM34.7958 24.6967H32.9536V21.661H34.7958V24.6967Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5476 25.0014H35.0922V21.3591H37.5476V25.0014Z",
    fill: "#FFDE0F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7842 25.3033H37.8614V21.0544H34.7929L34.7842 25.3033ZM37.2396 24.6967H35.3973V21.661H37.2396V24.6967Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0893 28.6409H32.634V24.9986H35.0893V28.6409Z",
    fill: "#FFDE0F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3405 28.9457H35.4089V24.6881H32.3405V28.9457ZM34.7958 28.3391H32.9536V25.3033H34.7958V28.3391Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5476 28.6409H35.0922V24.9986H37.5476V28.6409Z",
    fill: "#FFDE0F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7842 28.9457H37.8614V24.6881H34.7929L34.7842 28.9457ZM37.2396 28.3391H35.3973V25.3033H37.2396V28.3391Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0893 34.7125H32.634V31.0701H35.0893V34.7125Z",
    fill: "#8DD4FC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3405 35.0172H35.4089V30.7682H32.3405V35.0172ZM34.7958 34.4106H32.9536V31.3748H34.7958V34.4106Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5476 34.7125H35.0922V31.0701H37.5476V34.7125Z",
    fill: "#8DD4FC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7842 35.0172H37.8614V30.7682H34.7929L34.7842 35.0172ZM37.2396 34.4106H35.3973V31.3748H37.2396V34.4106Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0893 38.3548H32.634V34.7125H35.0893V38.3548Z",
    fill: "#8DD4FC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3405 38.6595H35.4089V34.4106H32.3405V38.6595ZM34.7958 38.0529H32.9536V35.0172H34.7958V38.0529Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5476 38.3548H35.0922V34.7125H37.5476V38.3548Z",
    fill: "#8DD4FC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7842 38.6595H37.8614V34.4106H34.7929L34.7842 38.6595ZM37.2396 38.0529H35.3973V35.0172H37.2396V38.0529Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1815 18.9385H32.631V16.5093C32.631 16.3497 32.5992 16.1918 32.5374 16.0444C32.4756 15.897 32.385 15.7631 32.2709 15.6505C32.1567 15.5378 32.0212 15.4485 31.872 15.3877C31.7229 15.3269 31.5632 15.2958 31.4019 15.2961C31.0767 15.2961 30.7648 15.424 30.5349 15.6515C30.3049 15.879 30.1757 16.1876 30.1757 16.5093L30.1815 18.9385Z",
    fill: "#FFDE0F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8735 19.226H32.942V16.4949C32.942 16.0924 32.7803 15.7063 32.4926 15.4216C32.2049 15.137 31.8147 14.9771 31.4078 14.9771C31.0009 14.9771 30.6106 15.137 30.3229 15.4216C30.0352 15.7063 29.8735 16.0924 29.8735 16.4949V19.226ZM32.3289 18.6194H30.4895V16.4949C30.4825 16.3711 30.5011 16.2472 30.5441 16.1308C30.5871 16.0144 30.6538 15.9078 30.7399 15.8177C30.8259 15.7276 30.9297 15.6559 31.0448 15.6068C31.1599 15.5578 31.2839 15.5325 31.4092 15.5325C31.5345 15.5325 31.6585 15.5578 31.7736 15.6068C31.8887 15.6559 31.9925 15.7276 32.0786 15.8177C32.1647 15.9078 32.2313 16.0144 32.2743 16.1308C32.3173 16.2472 32.3359 16.3711 32.3289 16.4949V18.6194Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6578 12.1627V8H20.9762V15.2847L24.6578 12.1627Z",
    fill: "#FF8537"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1405_22090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 34,
    fill: "white",
    transform: "matrix(-1 0 0 1 40 8)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouse3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house3.6b97878f023bdfd0074e59878ce032fa.svg";